import { render, staticRenderFns } from "./StudentsManagement.vue?vue&type=template&id=e55aa6c0&scoped=true"
import script from "./StudentsManagement.vue?vue&type=script&lang=ts"
export * from "./StudentsManagement.vue?vue&type=script&lang=ts"
import style0 from "./StudentsManagement.vue?vue&type=style&index=0&id=e55aa6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55aa6c0",
  null
  
)

export default component.exports